export default __webpack_public_path__ + "images/pending-icon.004588d1.svg";